import { useState, useEffect, useContext } from 'react';
import { getTickets2 } from '../../services/product';
import { useNavigate } from 'react-router-dom';
import { TransactionContext } from '../../contexts/TransactionContext';
import { useTranslation } from 'react-i18next';
import { Tickets } from '../../components/tickets';
import { EVENTID } from '../../helpers/constants';
import Banner1920 from '../../assets/images/banner1920.webp';
import { useError } from '../../hooks/useError';

export const Cart = () => {
  const [t, i18n] = useTranslation();
  const navigate = useNavigate();
  const { setCart, firstStep, email, loadedTickets, setUtm } =
    useContext(TransactionContext);
  const [tickets, setTickets] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const { goToFieldWithError } = useError();

  const updateTicketCount = (value, index) =>
    setTickets((prevState) => {
      const newState = [...prevState];
      const currentCount = newState[index].count;
      const newCount = currentCount + value;
      if (newState[index] === undefined || newCount > 1 || newCount < 0) {
        return newState;
      }
      newState[index] = { ...newState[index], count: newCount };
      return newState;
    });

  const handleAddTicket = (e, index) => {
    const ticketOnCart = tickets.filter((ticket) => ticket.count > 0);
    if (ticketOnCart.length === 0) {
      updateTicketCount(1, index);
      setDisabled(true);
      goToFieldWithError('tickets-buy');
    }
  };

  const handleRemoveTicket = (e, index) => {
    const ticketOnCart = tickets[index].count === 1;
    if (ticketOnCart) {
      updateTicketCount(-1, index);
      setDisabled(false);
    }
  };

  const handleBuy = (e) => {
    e.preventDefault();
    const ticketToBuy = tickets.filter((ticket) => ticket.count > 0);
    if (ticketToBuy.length > 0) {
      setCart(ticketToBuy);
      navigate('/pagamento');
    }
  };

  useEffect(() => {
    const fetchTickets = async () => {
      i18n.changeLanguage('pt');
      document.documentElement.setAttribute('lang', t('language'));
      document.title = t('title');

      const urlParams = new URLSearchParams(window.location.search);
      const currentUtm = {
        utmSource: urlParams.get('utm_source') || 'outros',
        utmMedium: urlParams.get('utm_medium') || 'outros',
        utmCampaign: urlParams.get('utm_campaign') || 'outros',
        utmTerm: urlParams.get('utm_term') || 'outros',
        utmContent: urlParams.get('utm_content') || 'outros',
      };
      setUtm(currentUtm);

      const response =
        email === '' ? await getTickets2(EVENTID) : loadedTickets;
      const newTickets = response.map((ticket) => ({ ...ticket, count: 0 }));
      setTickets(newTickets);
      firstStep();
    };
    fetchTickets();
  }, []);

  return (
    <div className='max-h-full'>
      <div className='flex justify-center items-center'>
        <div className='flex flex-col items-center'>
          <img
            src={Banner1920}
            className='w-full h-[187px] md:w-[970px] md:h-[484px] object-fill'
            alt='Congresso Wainer'
          />

          {/* <div className='flex items-center justify-center w-full md:min-h-[484px]  mt-3 text-center'></div> */}

          <div className='flex flex-col min-h-[187px] md:w-[970px] md:min-h-[484px] mt-3 px-4'>
            <h2 className='text-white text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold leading-snug lg:leading-[56px] text-center'>
              Onde a Ciência encontra a prática
            </h2>
            <Tickets
              handleAdd={handleAddTicket}
              handleRemove={handleRemoveTicket}
              handleBuy={handleBuy}
              tickets={tickets}
              t={t}
              disabled={disabled}
            />

            <div className='space-y-4 mt-6'>
              {[
                {
                  categoria:
                    'Profissionais e Estudantes (Psicologia, Psiquiatria e Medicina)',
                  requisitos:
                    'Psicólogos, Psiquiatras e Médicos, ou estudantes matriculados em cursos de Psicologia, Medicina, ou residência em Psiquiatria com conclusão após 11 de setembro de 2025.',
                  lotes: ['Encerrado', 'Encerrado', 'R$ 1.999,00'],
                },
                {
                  categoria: 'Alunos Wainer',
                  requisitos:
                    'Participantes matriculados em cursos de formação, especializações ou cursos online do Grupo Wainer com conclusão prevista até 11 de março de 2026.',
                  lotes: ['Encerrado', 'Encerrado', 'R$ 1.899,00'],
                },
                {
                  categoria:
                    'Outras Áreas (Profissionais da saúde ou educação)',
                  requisitos:
                    'Profissionais ou estudantes de saúde e educação, como: nutricionista, fisioterapeuta, fonoaudiólogo, etc.',
                  lotes: ['Encerrado', 'Encerrado', 'R$ 1.799,00'],
                },
                {
                  categoria: 'Pesquisadores',
                  requisitos:
                    'É necessário submeter trabalho científico. Categoria limitada a 50 inscrições.',
                  lotes: ['Encerrado', 'Encerrado', 'R$ 1.849,00'],
                },
                {
                  categoria: 'VIP',
                  requisitos:
                    'Qualquer categoria que deseje usufruir dos benefícios VIP.',
                  lotes: ['Encerrado', 'Encerrado', 'R$ 2.299,00'],
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className='border border-slate-600 rounded-lg p-4 text-white'
                >
                  <h4 className='font-semibold text-lg mb-2'>
                    {item.categoria}
                  </h4>
                  <p className='text-sm mb-3'>{item.requisitos}</p>
                  <div className='grid grid-cols-3 gap-2 text-sm'>
                    <div>
                      <span className='block font-medium'>Lote 1</span>
                      <span>{item.lotes[0]}</span>
                    </div>
                    <div>
                      <span className='block font-medium'>Lote 2</span>
                      <span>{item.lotes[1]}</span>
                    </div>
                    <div>
                      <span className='block font-medium'>Lote 3</span>
                      <span>{item.lotes[2]}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className='text-white mt-6 text-base leading-relaxed mb-6'>
              <h3 className='text-lg font-semibold mb-2'>
                Comprovação de Categoria:
              </h3>
              <p className='text-justify mb-4 text-sm sm:text-base'>
                Os documentos comprobatórios, quando não forem anexados via
                site, devem ser enviados ao e-mail{' '}
                <a
                  href='mailto:eventos@wainerpsicologia.com.br'
                  className='underline text-teal-300'
                >
                  eventos@wainerpsicologia.com.br
                </a>{' '}
                para análise e confirmação da inscrição no prazo máximo de 15
                dias após a inscrição, conforme relação a seguir:
              </p>

              <ul className='list-disc list-inside text-sm sm:text-base space-y-2 mb-6'>
                <li>
                  Categoria profissional deverá constar número de registro no
                  conselho da categoria ou cópia do diploma de graduação.
                </li>
                <li>
                  Categoria estudante de graduação: serão aceitos um ou mais dos
                  seguintes documentos comprobatórios: carteirinha de estudante
                  válida, declaração de matrícula ou comprovante de pagamento da
                  mensalidade.
                </li>
                <li>Categoria aluno Wainer não necessita de comprovação.</li>
                <li>
                  Categoria outras áreas: enviar carteira profissional ou
                  documento de estudante de graduação.
                </li>
              </ul>

              <p className='mb-4 text-sm sm:text-base'>
                Caso haja a necessidade de desistência de participação no
                evento, pedimos que a solicitação seja realizada através do
                formulário{' '}
                <a
                  href='https://docs.google.com/forms/d/e/1FAIpQLScSmWQacjUsDWsPZV6jygnt1U2HZvtIvCCit0oYI6bSmZl2fg/viewform'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='underline text-teal-300'
                >
                  aqui
                </a>
                , conforme os critérios descritos a seguir.
              </p>

              <h3 className='text-lg font-semibold mb-2'>
                Prazos e Condições para Reembolso
              </h3>
              <p className='mb-4 text-sm sm:text-base'>
                Em caso de desistência formal, o reembolso será realizado até 45
                dias após o término do evento:
              </p>

              {/* <div className='overflow-x-auto mb-6'>
                <table className='min-w-[600px] w-full text-sm text-left border border-slate-600'>
                  <thead className='bg-slate-700 text-white'>
                    <tr>
                      <th className='p-3 border border-slate-600'>
                        Justificativa
                      </th>
                      <th className='p-3 border border-slate-600'>
                        Prazo para Solicitação
                      </th>
                      <th className='p-3 border border-slate-600'>
                        Valor a ser Reembolsado
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      [
                        'Sem justificativa',
                        'Até 60 dias antes do Congresso',
                        '60% do valor pago',
                      ],
                      [
                        'Sem justificativa',
                        'Até 30 dias antes do Congresso',
                        '40% do valor pago',
                      ],
                      [
                        'Sem justificativa',
                        'Até 60 dias antes do Congresso',
                        '90% do valor pago (crédito)',
                      ],
                      [
                        'Sem justificativa',
                        'Até 30 dias antes do Congresso',
                        '70% do valor pago (crédito)',
                      ],
                      [
                        'Problemas de saúde',
                        'Até 5 dias antes do Congresso',
                        '80% do valor pago',
                      ],
                      [
                        'Desistência de compra',
                        'Até 7 dias após o pagamento',
                        '100% do valor pago',
                      ],
                    ].map(([justificativa, prazo, valor], i) => (
                      <tr
                        key={i}
                        className='border-t border-slate-600'
                      >
                        <td className='p-3 border border-slate-600'>
                          {justificativa}
                        </td>
                        <td className='p-3 border border-slate-600'>{prazo}</td>
                        <td className='p-3 border border-slate-600'>{valor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}

              <div className='hidden md:table mb-6'>
                <table className='min-w-[600px] w-full text-sm text-left border '>
                  <thead className=' text-white'>
                    <tr>
                      <th className='p-3 border '>Justificativa</th>
                      <th className='p-3 border '>Prazo para Solicitação</th>
                      <th className='p-3 border '>Valor a ser Reembolsado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      [
                        'Sem justificativa',
                        'Até 60 dias antes do Congresso',
                        '60% do valor pago',
                      ],
                      [
                        'Sem justificativa',
                        'Até 30 dias antes do Congresso',
                        '40% do valor pago',
                      ],
                      [
                        'Sem justificativa',
                        'Até 60 dias antes do Congresso',
                        '90% do valor pago (crédito)',
                      ],
                      [
                        'Sem justificativa',
                        'Até 30 dias antes do Congresso',
                        '70% do valor pago (crédito)',
                      ],
                      [
                        'Sem justificativa',
                        'Últimos 30 dias antes do ínicio do Congresso',
                        'Sem reembolso. Crédito de 40% do valor pago para eventos Wainer',
                      ],
                      [
                        'Problemas de saúde',
                        'Até 5 dias antes do Congresso',
                        '80% do valor pago',
                      ],
                      [
                        'Desistência de compra',
                        'Até 7 dias após o pagamento',
                        '100% do valor pago',
                      ],
                    ].map(([justificativa, prazo, valor], i) => (
                      <tr
                        key={i}
                        className='border-t border-slate-600'
                      >
                        <td className='p-3 border border-slate-600'>
                          {justificativa}
                        </td>
                        <td className='p-3 border border-slate-600'>{prazo}</td>
                        <td className='p-3 border border-slate-600'>{valor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className='md:hidden  flex flex-col gap-3 mt-4'>
                {[
                  {
                    justificativa: 'Sem justificativa',
                    prazo: 'Até 60 dias antes do Congresso',
                    valor: '60% do valor pago',
                  },
                  {
                    justificativa: 'Sem justificativa',
                    prazo: 'Até 30 dias antes do Congresso',
                    valor: '40% do valor pago',
                  },
                  {
                    justificativa: 'Sem justificativa',
                    prazo: 'Até 60 dias antes do Congresso',
                    valor: '90% do valor pago (crédito)',
                  },
                  {
                    justificativa: 'Sem justificativa',
                    prazo: 'Até 30 dias antes do Congresso',
                    valor: '70% do valor pago (crédito)',
                  },
                  {
                    justificativa: 'Sem justificativa',
                    prazo: 'Últimos 30 dias antes do ínicio do Congresso',
                    valor:
                      'Sem reembolso. Crédito de 40% do valor pago para eventos Wainer',
                  },
                  {
                    justificativa: 'Problemas de saúde',
                    prazo: 'Até 5 dias antes do Congresso',
                    valor: '80% do valor pago',
                  },
                  {
                    justificativa: 'Desistência de compra',
                    prazo: 'Até 7 dias após o pagamento',
                    valor: '100% do valor pago',
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className='flex flex-col sm:flex-row gap-2 sm:gap-4 p-4 text-white rounded-md border text-sm'
                  >
                    <div className='flex-[1]'>
                      <span className='font-semibold block sm:inline'>
                        Justificativa:
                      </span>{' '}
                      <span>{item.justificativa}</span>
                    </div>
                    <div className='flex-[1]'>
                      <span className='font-semibold block sm:inline'>
                        Prazo:
                      </span>{' '}
                      <span>{item.prazo}</span>
                    </div>
                    <div className='flex-[1]'>
                      <span className='font-semibold block sm:inline'>
                        Valor:
                      </span>{' '}
                      <span>{item.valor}</span>
                    </div>
                  </div>
                ))}
              </div>

              <h3 className='text-lg font-semibold mb-2 mt-6'>
                Procedimentos para Solicitação de Reembolso
              </h3>
              <ul className='list-disc list-inside text-sm sm:text-base space-y-2 mb-6'>
                <li>
                  Sem justificativa: solicitar via{' '}
                  <a
                    href='https://docs.google.com/forms/d/e/1FAIpQLScSmWQacjUsDWsPZV6jygnt1U2HZvtIvCCit0oYI6bSmZl2fg/viewform'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='underline text-teal-300'
                  >
                    formulário de reembolso
                  </a>
                  .
                </li>
                <li>
                  Problemas de saúde: anexar atestado médico e comprovante de
                  pagamento.
                </li>
                <li>Duplicidade de pagamento: anexar os comprovantes.</li>
                <li>
                  Desistência de compra: solicitar via formulário e anexar
                  comprovante.
                </li>
              </ul>

              <p className='text-sm sm:text-base'>
                <strong>Observações:</strong> A carta de crédito será válida por
                2 anos. O prazo para solicitação deve ser respeitado. Permutas
                são permitidas até 30 dias antes do evento. Mudança de
                titularidade deve ser comunicada pelo e-mail{' '}
                <a
                  href='mailto:eventos@wainerpsicologia.com.br'
                  className='underline text-teal-300'
                >
                  eventos@wainerpsicologia.com.br
                </a>{' '}
                com os dados do novo titular.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
